import apiUrl from '../../../../../constants';
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';

import {
  Validator
} from 'vee-validate'

export default {
  name: 'Approve Thank',
  components: {
    VueElementLoading
  },
  props: [],
  data() {
    return {
      Loading : false,
      confirmationFLag : true,
      outputString : '',
      reloadString : 'Your Request is processing, do not reload page....',
      approvalStatus : '',
      rejectReson : '',
      commnet : ''
    }
  },
  computed: {

  },
  mounted() {

    // var userdetailEncrypt = window.localStorage.getItem('vmaccessuserdata')
    // window.localStorage.setItem('vmaccesspermissiondata', '');
    // window.localStorage.setItem('vmaccessuserdata', '');
    // window.localStorage.setItem('isLoggedIn','');
    //this.getApproval(this.$route.params);
    this.approvalStatus = this.$route.params.accept
  },
  methods: {
    cancelmodal(approve){
      this.confirmationFLag = false;
      if (approve == 'reject') {
        this.reloadString = '';
        this.outputString = "Thank you ,Process Cancel !!!!!";
        this.confirmationFLag = false;
        return true;
      }
    },
    getApproval(approve){
      this.confirmationFLag = false;
      this.Loading = true;
      let approvalobj = this.$route.params;
      let payload = {
        encrptString : approvalobj.encryiptedJSON,
        approvalStatus : approvalobj.accept
      }

      if(this.rejectReson) payload.rejectReson = this.rejectReson;
      if(this.commnet) payload.commnet = this.commnet;

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'approval/updateClientStatus',
          'data': payload,
          header:{
            'content-type': 'application/json',
          },
        })
        .then(result => {
          if(result.data.code == 200){
            if(this.$route.params.accept == 1){
              this.outputString = "Thank you , Client On-boarded successfully !";
            } else {
              this.outputString = "Thank you ,Client Reject successfully!";
            }
            this.Loading = false;
            this.reloadString = "";
          }else if (result.data.code == 202){
            this.outputString = result.data.message;
            this.Loading = false;
            this.reloadString = "";
          } else {
            this.outputString = "Your Request not proccessed, please retry";
            this.Loading = false;
            this.reloadString = "";
          }

        }, error => {
          console.log('errors exist', this.errors)
        })

    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.getApproval(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/cargoclient/approvalflow/approvethank/approvethank.component.js